module.exports = __webpack_public_path__ + "static/media/headshot jw copy.7fce94f5.jpeg";